// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14 7.25 L14 12.75 C14 13.44 13.44 14 12.75 14 L10.75 14 C10.06 14 9.5 13.44 9.5 12.75 L9.5 7.25 C9.5 6.56 10.06 6 10.75 6 L12.75 6 C13.44 6 14 6.56 14 7.25 Z',
  'M6.5 7.25 L6.5 12.75 C6.5 13.44 5.94 14 5.25 14 L3.25 14 C2.56 14 2 13.44 2 12.75 L2 7.25 C2 6.56 2.56 6 3.25 6 L5.25 6 C5.94 6 6.5 6.56 6.5 7.25 Z',
  'M10 1.5 L8 3.5 L6 1.5',
];
